import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AddChartAccount from "./AddChartAccount";
import MainContainer from "../../../components/container/MainContainer";
import LocationHeader from "../../../components/header/LocationHeader";
import Modal from "../../../components/modal/Modal";
import Loading from "../../../components/loading/Loading";
import Table from "../../../components/tables/Table";
import { getAccounts, unsetAccounts } from "../../../features/accountsSlice";
import { openModal } from "../../../features/modalSLice";
import { useAuthorization } from "../../../hooks/useAuthorization";
import loadStatus from "../../../util/loadStatus";
import NetworkError from "../../error/NetworkError";
import { useLocation } from "react-router-dom";

const ChartAccount = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const modalContent = useSelector((state) => state.modal.content);
  const accounts = useSelector((state) => state.accounts.data);
  const loading = useSelector((state) => state.accounts.load.getAccounts);
  const { isAuthorized } = useAuthorization();

  const title = "Accounts";
  // const links = [{ to: "/countries", name: "Countries" }];

  const columns = [
    { id: "num", text: "Num" },
    { id: "name", text: "Name" },
    { id: "account_type", text: "Type" },
    { id: "account_category", text: "Category" },
  ];

  const openAddAccountModal = () => {
    dispatch(openModal(<AddChartAccount />));
  };

  useEffect(() => {
    dispatch(getAccounts());
    return () => {
      dispatch(unsetAccounts());
    };
  }, []);

  if (loading === loadStatus.loading) {
    return <Loading />;
  }

  if (loading === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <>
      <Modal>{modalContent}</Modal>
      <MainContainer>
        <LocationHeader
          title={title}
          links={[]}
          action={openAddAccountModal}
          authorized={isAuthorized("settings", "create")}
        />
        <main className="table-container">
          <Table columns={columns} data={accounts} link />
        </main>
      </MainContainer>
    </>
  );
};

export default ChartAccount;
